import PropTypes from 'prop-types';
import React from 'react';

import generalStyles from './style/general.css';
import ratioStyles from './style/ratio.css';

const styles = { ...generalStyles, ...ratioStyles };

const RATIO_PREFIX = 'ratio-';

/**
 * The aspect ratio of an element describes the proportional relationship
 * between its width and its height. Two common video aspect ratios are `4:3`
 * (the universal video format of the 20th century), and `16:9` (universal for HD
 * television and European digital television).
 */
export default function AspectRatio({ ratio, children }) {
  return (
    <div className={styles.aspectRatio}>
      <div className={styles[`${RATIO_PREFIX}${ratio}`]} />
      <div className={styles.aspectRatioContent}>{children}</div>
    </div>
  );
}

AspectRatio.propTypes = {
  ratio: PropTypes.oneOf(['16-9', '4-3', '6-4', '8-5', '7-5', '1-1'])
    .isRequired,
  /** Accepts any node. */
  children: PropTypes.node,
};

AspectRatio.defaultProps = {
  ratio: '16-9',
};



// WEBPACK FOOTER //
// ./packages/marvel-ui-aspect-ratio/AspectRatio/index.js